export enum AnnouncementType {
  EMERGENCY = 'emergency',
  ALERT = 'alert',
  INFO = 'info'
}

export type Announcement = {
  id: number
  place?: string
  announcementType: AnnouncementType
  content: string
  publishDate?: string
  expirationDate?: string | null
  url: string | null
  displayMethod: '_self' | '_blank' | null
}

export type Notification = {
  id: number
  places: string[]
  notificationType: string
  style: AnnouncementType
  content: string
  createdAt: string
  updatedAt: string
  url: string | null
  displayMethod: '_self' | '_blank' | null
}

export type StandardAnnouncement = {
  id: number,
  announcementType: AnnouncementType,
  content: string,
  url: string | null,
  displayMethod: '_self' | '_blank' | null
  publishDate?: string
}
